import { Route, Routes } from 'react-router-dom';

import { ProviderDirectoryLayout } from '@/components/provider-directory/v2/ProviderDirectoryLayout';
import { ProviderProfile } from '@/components/provider-directory/v2/ProviderProfile';
import { ProviderSearchHome } from '@/components/provider-directory/v2/ProviderSearchHome';

const ProviderDirectory = () => {
  return (
    <ProviderDirectoryLayout>
      <Routes>
        <Route index element={<ProviderSearchHome />} />
        <Route path=":serviceId" element={<ProviderProfile />} />
      </Routes>
    </ProviderDirectoryLayout>
  );
};

export default ProviderDirectory;
